import React from 'react';
import { connect } from 'react-redux';
import { Box } from '@mui/material';

import { State as RootState } from '@occc-app/rootRedux';

import { actions } from './redux';
import { MetaDataConfigurationGetStarted } from './components';

type State = RootState['offer'];
type Actions = typeof actions;
type Props = State & Actions;

class CreateGetStarted extends React.Component<Props, {}> {
  handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { id, value } = event.currentTarget;
    this.props.getStartedUpdate(id, value);
  };

  renderMetaDataFields() {
    const metaDataProps = {
      ...this.props.getStarted,
      getStartedUpdate: this.props.getStartedUpdate,
      fieldDisabled: () => false,
    };

    return <MetaDataConfigurationGetStarted {...metaDataProps} />;
  }

  render() {
    return <Box width={[1]}>{this.renderMetaDataFields()}</Box>;
  }
}

type MapStateToProps = (state: RootState) => RootState['offer'];
const mapStateToProps: MapStateToProps = ({ offer }) => offer;
export default connect(mapStateToProps, actions)(CreateGetStarted);
